import { useEffect, useState } from "react";
import { MapPin, Loader2, Truck } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { t } from "../lib/i18n";

const KEY = "ez_pin";

export default function DeliveryCheck({ productId, onResult = () => {} }) {
  const [pin, setPin] = useState(() => localStorage.getItem(KEY) || "");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const check = async (code = pin) => {
    if (!/^[1-9]\d{5}$/.test(code)) return setErr("Enter a valid 6-digit PIN code");
    setBusy(true); setErr("");
    try { const r = await api.get("/delivery/estimate", { params: { pincode: code, product_id: productId } }); setRes(r.data); onResult(r.data); localStorage.setItem(KEY, code); }
    catch (e) { setRes(null); onResult(null); setErr(errMsg(e)); } finally { setBusy(false); }
  };
  useEffect(() => { if (pin.length === 6) check(pin); }, []); // eslint-disable-line
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-4 space-y-2" data-testid="delivery-check">
      <p className="text-sm font-semibold flex items-center gap-2"><MapPin size={15} className="text-[#ff5500]" />{t("Check delivery date")}</p>
      <form onSubmit={(e) => { e.preventDefault(); check(); }} className="flex gap-2">
        <input data-testid="delivery-pincode-input" inputMode="numeric" maxLength={6} value={pin} onChange={(e) => { const v = e.target.value.replace(/\D/g, ""); setPin(v); if (v.length === 6) check(v); else { setRes(null); setErr(""); } }} placeholder="Enter 6-digit PIN code"
          className="flex-1 bg-black/40 border border-white/10 rounded-full px-4 h-10 text-sm outline-none focus:border-[#ff5500]" />
        <button data-testid="delivery-check-btn" disabled={busy} className="px-5 h-10 rounded-full bg-white text-black text-sm font-semibold disabled:opacity-50">{busy ? <Loader2 size={14} className="animate-spin" /> : t("Check")}</button>
      </form>
      {err && <p data-testid="delivery-error" className="text-xs text-red-400">{err}</p>}
      {res && !res.serviceable && <p data-testid="delivery-not-deliverable" className="text-sm font-semibold text-red-400">Not deliverable to your PIN {res.pincode}. The seller doesn't deliver to this area.</p>}
      {res?.serviceable && (
        <div data-testid="delivery-result" className="text-sm space-y-0.5">
          <p className="flex items-center gap-2 text-emerald-400 font-semibold"><Truck size={14} /><span data-testid="delivery-date">{res.label}</span></p>
          <p className="text-xs text-slate-400">To {res.city}, {res.state} · {res.cod ? "Cash on Delivery available" : "Prepaid only"}</p>
          {res.speeds && <p data-testid="delivery-speeds" className="text-xs text-slate-300">Standard FREE by <b>{res.speeds.standard.by}</b> · Fast ₹{res.speeds.express.fee} by <b>{res.speeds.express.by}</b></p>}
        </div>
      )}
    </div>
  );
}
